// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/symbol_index.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_vitesse_v1_entitlements } from "./entitlements_pb.js";
import { file_vitesse_v1_common } from "./common_pb.js";
/**
 * Describes the file vitesse/v1/symbol_index.proto.
 */
export const file_vitesse_v1_symbol_index = /*@__PURE__*/ fileDesc("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", [file_vitesse_v1_entitlements, file_vitesse_v1_common]);
/**
 * Describes the message vitesse.v1.PageCursor.
 * Use `create(PageCursorSchema)` to create a new message.
 */
export const PageCursorSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_symbol_index, 0);
/**
 * @generated from enum vitesse.v1.PageCursor.Direction
 */
export var PageCursor_Direction;
(function (PageCursor_Direction) {
    /**
     * forward (next page)
     *
     * @generated from enum value: DIRECTION_UNSPECIFIED = 0;
     */
    PageCursor_Direction[PageCursor_Direction["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: DIRECTION_FORWARD = 1;
     */
    PageCursor_Direction[PageCursor_Direction["FORWARD"] = 1] = "FORWARD";
    /**
     * @generated from enum value: DIRECTION_BACKWARD = 2;
     */
    PageCursor_Direction[PageCursor_Direction["BACKWARD"] = 2] = "BACKWARD";
})(PageCursor_Direction || (PageCursor_Direction = {}));
/**
 * Describes the enum vitesse.v1.PageCursor.Direction.
 */
export const PageCursor_DirectionSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_symbol_index, 0, 0);
/**
 * Describes the message vitesse.v1.SymbolQuery.
 * Use `create(SymbolQuerySchema)` to create a new message.
 */
export const SymbolQuerySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_symbol_index, 1);
/**
 * Describes the message vitesse.v1.SymbolRow.
 * Use `create(SymbolRowSchema)` to create a new message.
 */
export const SymbolRowSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_symbol_index, 2);
/**
 * Describes the message vitesse.v1.PrefetchedChildren.
 * Use `create(PrefetchedChildrenSchema)` to create a new message.
 */
export const PrefetchedChildrenSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_symbol_index, 3);
/**
 * Describes the message vitesse.v1.SymbolPage.
 * Use `create(SymbolPageSchema)` to create a new message.
 */
export const SymbolPageSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_symbol_index, 4);
/**
 * Describes the message vitesse.v1.IndexerSubscribeRequest.
 * Use `create(IndexerSubscribeRequestSchema)` to create a new message.
 */
export const IndexerSubscribeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_symbol_index, 5);
/**
 * Describes the message vitesse.v1.IndexerSubscribeReply.
 * Use `create(IndexerSubscribeReplySchema)` to create a new message.
 */
export const IndexerSubscribeReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_symbol_index, 6);
/**
 * Describes the message vitesse.v1.IndexerUnsubscribeRequest.
 * Use `create(IndexerUnsubscribeRequestSchema)` to create a new message.
 */
export const IndexerUnsubscribeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_symbol_index, 7);
/**
 * SortOrder over the result rowset. The indexer translates these to ORDER BY
 * clauses over its per-controller materialized view.
 *
 * @generated from enum vitesse.v1.SortOrder
 */
export var SortOrder;
(function (SortOrder) {
    /**
     * implementation-defined (path-asc)
     *
     * @generated from enum value: SORT_ORDER_UNSPECIFIED = 0;
     */
    SortOrder[SortOrder["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: SORT_ORDER_PATH_ASC = 1;
     */
    SortOrder[SortOrder["PATH_ASC"] = 1] = "PATH_ASC";
    /**
     * @generated from enum value: SORT_ORDER_LAST_MODIFIED_DESC = 2;
     */
    SortOrder[SortOrder["LAST_MODIFIED_DESC"] = 2] = "LAST_MODIFIED_DESC";
    /**
     * @generated from enum value: SORT_ORDER_LABEL_ASC = 3;
     */
    SortOrder[SortOrder["LABEL_ASC"] = 3] = "LABEL_ASC";
})(SortOrder || (SortOrder = {}));
/**
 * Describes the enum vitesse.v1.SortOrder.
 */
export const SortOrderSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_symbol_index, 0);
/**
 * FlagFilter is a tri-state filter over a boolean SymbolDescriptor flag
 * (priority / locked / deletable). UNSPECIFIED leaves the flag unfiltered;
 * TRUE / FALSE restrict the rowset to symbols whose flag is set / clear. This
 * is what powers the indexer "views" — deletable_filter=TRUE is the "deletable
 * symbols" view, locked_filter=TRUE/FALSE the "locked"/"unlocked" views, etc.
 *
 * @generated from enum vitesse.v1.FlagFilter
 */
export var FlagFilter;
(function (FlagFilter) {
    /**
     * no filter on this flag (default)
     *
     * @generated from enum value: FLAG_FILTER_UNSPECIFIED = 0;
     */
    FlagFilter[FlagFilter["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * only rows where the flag is set
     *
     * @generated from enum value: FLAG_FILTER_TRUE = 1;
     */
    FlagFilter[FlagFilter["TRUE"] = 1] = "TRUE";
    /**
     * only rows where the flag is clear
     *
     * @generated from enum value: FLAG_FILTER_FALSE = 2;
     */
    FlagFilter[FlagFilter["FALSE"] = 2] = "FALSE";
})(FlagFilter || (FlagFilter = {}));
/**
 * Describes the enum vitesse.v1.FlagFilter.
 */
export const FlagFilterSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_symbol_index, 1);
/**
 * The browser-facing service. Exposed via api-gateway; api-gateway bridges
 * each Subscribe call to cmd.indexer.subscribe / cmd.indexer.unsubscribe
 * over NATS.
 *
 * @generated from service vitesse.v1.SymbolIndex
 */
export const SymbolIndex = /*@__PURE__*/ serviceDesc(file_vitesse_v1_symbol_index, 0);
/**
 * The browser-facing service for an integration's discovered SCHEMA — the
 * "topic" archetype (MQTT/Sparkplug-style push sources with no native
 * pagination, whose namespace the indexer materializes + paginates). Same shape
 * as SymbolIndex: the schema is "paths with metadata", browsed as paginated
 * SymbolPages. Served by the symbol-indexer binary run in --mode=integrations;
 * api-gateway bridges each Subscribe to cmd.integration-indexer.subscribe /
 * cmd.integration-indexer.unsubscribe over NATS. SymbolQuery.controller_id
 * carries the integration id. Reuses SymbolQuery / SymbolPage /
 * IndexerSubscribeRequest verbatim — only the routed NATS namespace differs.
 *
 * Scope: ONLY push / non-queryable integrations route here. Queryable sources
 * (SQL, GraphQL, OPC-UA Browse, object stores) are NOT indexed — their schema +
 * rows are proxied live, so they do NOT use this service.
 *
 * @generated from service vitesse.v1.IntegrationIndex
 */
export const IntegrationIndex = /*@__PURE__*/ serviceDesc(file_vitesse_v1_symbol_index, 1);
//# sourceMappingURL=symbol_index_pb.js.map